import { useMemo } from 'react';
import { useTagsForEntityType } from 'src/hooks/useTagsForEntityType';
import { ActionOutboxEntityType } from 'src/WebApiController';

export function useExistingTagNamesForPersistentTag(disabled?: boolean) {
  const { tagsMetadata: tagsMetadataForSale } = useTagsForEntityType(
    disabled ? undefined : ActionOutboxEntityType.Sale
  );

  const { tagsMetadata: tagsMetadataForPurchase } = useTagsForEntityType(
    disabled ? undefined : ActionOutboxEntityType.Purchase
  );

  const { tagsMetadata: tagsMetadataForListing } = useTagsForEntityType(
    disabled ? undefined : ActionOutboxEntityType.Listing
  );

  const existingTagNamesAcrossEntityTypes = useMemo(() => {
    return [
      ...(tagsMetadataForSale ?? []).map((t) => t.key),
      ...(tagsMetadataForPurchase ?? []).map((t) => t.key),
      ...(tagsMetadataForListing ?? []).map((t) => t.key),
    ];
  }, [tagsMetadataForSale, tagsMetadataForPurchase, tagsMetadataForListing]);

  return {
    // Used for validation of the new persistent tag name - need to check across all entity types
    existingTagNamesAcrossEntityTypes: existingTagNamesAcrossEntityTypes,
  };
}
